function yosUpdateShipping(cart) {
  var ids = [4613751799879,4613760122951,6543304917063,4613761105991,4613760516167,4613756813383,4613761859655];
  var boxes = cart.items.reduce(function(n, item) { return n + (ids.indexOf(item.product_id) >= 0 ? item.quantity : 0); }, 0);
  var allBoxes = cart.items.every(function(item) { return ids.indexOf(item.product_id) >= 0 && item.final_price === 2700; });
  document.querySelectorAll('[data-yos-shipping]').forEach(function(el) {
    el.hidden = cart.item_count === 0 || cart.currency !== 'USD';
    var key = cart.total_price > 7500 ? 'unlocked' : allBoxes && boxes === 1 && cart.total_price === 2700 ? 'one' : allBoxes && boxes === 2 && cart.total_price === 5400 ? 'two' : 'fallback';
    el.querySelector('[data-yos-shipping-message]').textContent = el.dataset[key];
    el.querySelector('[data-yos-shipping-progress]').value = Math.min(cart.total_price, 7501);
  });
}
 jQuery(document).ready(function($){
   var body = $('body'),
        doc = $(document),
        html = $('html'),
        win = $(window);
   var wishListsArr = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];
    var compareArr = localStorage.getItem('compareArr') ? JSON.parse(localStorage.getItem('compareArr')) : [];

    localStorage.setItem('items', JSON.stringify(wishListsArr));
    if (wishListsArr.length) {
        wishListsArr = JSON.parse(localStorage.getItem('items'));
    };
   
   var myOffcanvas = document.getElementById('yfb-sidecart');
          var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
          // bsOffcanvas.show();
   $('.blog_head ul li:first-child').addClass('active');
    $('.yfb_ingredients_loc .locations .loc .pin').on('click', function(){
      var t = $(this); t.parent().addClass('active').siblings().removeClass('active');
    });
    $(document).on('click', function(e) {
        // Check if click is outside both the menu button and menu content
        if (!$(e.target).closest('.yfb_ingredients_loc .locations .loc .pin').length) {
          $('.yfb_ingredients_loc .locations .loc').removeClass('active');
        }
      });
  var yfb = {
    init: function(){
      this.main_menu_fixed();
      this.mobile_menu();
      this.mobile_tabs();
      this.getItems();
      this.wishlist();
      this.wishlisticons();
      this.ajax_pagination();
      this.set_page_items();
      this.removeitems();
    },
    main_menu_fixed: function(){
      $(window).scroll(function() {
      scroll = $(window).scrollTop();
      var e = $(".site-header");
      scroll >= 10 ? e.addClass("sticky") : e.removeClass("sticky");
      });
      var lastScrollTop = 0;
      $(window).scroll(function() {
          var scrollTop = $(this).scrollTop();
          var e = $(".site-header");
          if (scrollTop < lastScrollTop) {
              // Scrolling up
              scrollTop >= 210 ? e.addClass("fixed") : e.removeClass("fixed");
          } else {
              // Scrolling down
              e.removeClass("fixed");
          }
          lastScrollTop = scrollTop;
      });
    },
    mobile_menu: function(){
      $('li.submenu a.alink').on('click', function(e){
        e.preventDefault();
        var t = $(this); t.parent().toggleClass('open_dropdown'); t.parent().find('ul').slideToggle();
        t.parent().siblings().removeClass('open_dropdown');t.parent().siblings().find('ul').slideUp();
      });
      $('.site_footer .ft-widget h3.toggle_menu').on('click', function(){
        var t = $(this); t.parent().toggleClass('active'); t.next().slideToggle();
      });
    },
    mobile_tabs: function(){
      $('a[href="#pxaccount"]').on('click', function(e){
        e.preventDefault();
    		$('[data-user-mobile-toggle]').trigger('click');
      });
      $('a[href="#home"]').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({
          scrollTop: jQuery("#shopify-section-header").offset().top
        }, 1000); 
         $('.yfb_search_bar input[type="search"]').focus();
      });
      $('a[href="#search"]').on('click', function(e){
        e.preventDefault();
      	$('.yfb_search_bar').slideToggle();
         $('.yfb_search_bar input[type="search"]').focus();
      });
    },
    getItems: function(){
      $.getJSON("/cart.json", function(e) {
        yosUpdateShipping(e);
		var total_cart_price = Shopify.formatMoney(e.original_total_price);
		$("[data-cart-items],a.menu-cart-icon span").text(e.item_count);
    $('body #cart_note').remove();
    if( cartlimit == true ){ 
      if( e.item_count > cart_num ){
        $('.cartbtn').html('');
        $('#gocheck').css('opacity',0); $('body .cartbtn').addClass('d-block');
        $('.cartbtn,.order_summary').append('<p id="cart_note" class="cart_note mt-3 alert alert-danger">'+cartmsg+'</p>');
      }
    }
    if( e.item_count <= cart_num ){
      $('#gocheck').css('opacity',1);
      $('body #cart_note').remove();
      $('body .cartbtn').removeClass('d-block');
      $('.cartbtn').html('<a href="/checkout" class="btn btn-view-cart" id="mc-limit">Checkout</a><a class="btn btn-view-cart" href="/cart">View cart</a>');
    }
        if( e.item_count == 0 ){
          $('.no-item-cart').show();
          $('form.cart-form.wrapper-template-cart').hide();
        }else{
          $('.no-item-cart').hide();
          $('form.cart-form.wrapper-template-cart').show();
        }
        if( e.item_count > 1 ){
          $('[data-cartabre]').text('are');
        }else{
          $('[data-cartabre]').text('is');
        }
        $("#yfb-sidecart .total span.price,.cart_sumary .total span.price,[data-totalcart]").html(Shopify.formatMoney(e.items_subtotal_price));
        if( e.items.length == 0 ){
          $('.no-items').show();
        }else{
          $('.no-items').hide();
        }
        $('[data-toggle="tooltip"]').tooltip();
      });
      $.get('/cart?view=drawer', function (cartitems) {
        $('#cartdrawer').html(cartitems);
      }); 
      var sortby = $('a.dropdown-item.cactive').text();
      $('#tabletxt').text(sortby);
    },
    wishlist:function(ProductHandle){
      var wishlistElm = $('[data-product-handle="'+ ProductHandle +'"]'),
            idxArr = wishListsArr.indexOf(ProductHandle);
        $('#WishCounter').text(wishListsArr.length);
        if(idxArr >= 0) {
            wishlistElm.addClass('whislist-added');
                wishlistElm.find('.wishlist-text').text('window.inventory_text.remove_wishlist'); 
        }
        else {
            wishlistElm.removeClass('whislist-added');
                wishlistElm.find('.wishlist-text').text('window.inventory_text.add_wishlist');
        };
      var iconWishListsSlt = '[data-icon-wishlist]';

            doc.off('click.addOrRemoveWishlist', iconWishListsSlt).on('click.addOrRemoveWishlist', iconWishListsSlt, function(e) {
                e.preventDefault();

                var self = $(this),
                    productId = self.data('id'),
                    ProductHandle = self.data('product-handle'),
                    idxArr = wishListsArr.indexOf(ProductHandle);

                if(!self.hasClass('whislist-added')) {
                    self.addClass('whislist-added');
                        self.find('.wishlist-text').text('window.inventory_text.remove_wishlist');

                    if($('[data-wishlist-container]').length) {
                        ella.createWishListTplItem(ProductHandle);
                    };

                    wishListsArr.push(ProductHandle);
                    localStorage.setItem('items', JSON.stringify(wishListsArr));
                } else {
                    self.removeClass('whislist-added');
                    $('[data-wishlist-added="wishlist-'+productId+'"]').remove();

                    wishListsArr.splice(idxArr, 1);
                    localStorage.setItem('items', JSON.stringify(wishListsArr));

                    if($('[data-wishlist-container]').length) {
                      
                    };
                };

                yfb.wishlist(ProductHandle);
            });
    },
    wishlisticons: function() {
        var wishListItems = JSON.parse(localStorage.getItem('items'));
      // var listitem = wishListItems.split(",");
        for (var i = 0; i < wishListItems.length; i++) {
            var icon = $('[data-product-handle="'+ wishListItems[i] +'"]');
            icon.addClass('whislist-added');
          $.get('/products/' + wishListItems[i] + '?view=wishlist', function (quick_response) {
            $('#yfb_wishlist').append(quick_response);
          }); 
        }
    },
    ajax_pagination: function(){ var count = 1;
      $(document.body).on('click', '.px-infinite-scrolling a', function(e){
        count++; e.preventDefault();
        $(this).append(' <div class="spinner-border spinner-border-sm"></div>');
        $.ajax({
            type: "get",
            url: $(this).data('href'),
            beforeSend: function () {
            },
            success: function (data) {
              var result = $(data).find('.product-collection.fav_products ul, .blog_list ul').html();
              var filterform = $(data).find('.filter-form').html();
              var pagebtn = $(data).find('.px-infinite-scrolling').html();
              $('.px-infinite-scrolling').html(pagebtn);
              $('.product-collection.fav_products ul, .blog_list ul').append(result);
              $('#filter-form').html(filterform); 
              $(".js-range-slider").ionRangeSlider({
                 onChange: function(rp){
                   $('input[name="filter.v.price.gte"]').val(rp.from);
                       $('input[name="filter.v.price.lte"]').val(rp.to);
                 },
                onFinish: function(){
                  $('#filter-form').append('<input type="hidden" name="sort_by" value="price-ascending" />');
                  $('#filter-form').submit();
                }
              });
              $('.loading-modal').hide();
              $("div.col-sidebar .filter-group ul li").slice(0, 10).show();
              $("div.col-sidebar .filter-groups ul li").slice(0, 10).show();
              $("ul#filtter-health-ingredients li").slice(0, 10).show();
              $("ul#filtter-brand li").slice(0, 10).show();
            }, 
            error: function (xhr, text) {},
            complete: function () {
              var st = $('#filter-form'),
               sf = st.serialize(); 
              window.history.pushState('page2', 'Title', '?'+sf);
            }
        });
      });
    },
    set_page_items: function(){
      $(document.body).on('click', '[data-setitemnumber] a',function(e){
       e.preventDefault();  
        var v = $(this).data('pnumber');
        $.ajax({
            type: "Post",
            url: '/cart.js',
            data: {
                "attributes[pagination]": v
            },
            success: function (data) {
                window.location.reload();
            },
            error: function (xhr, text) {
 
            },
            dataType: 'json'
        });
     });
      
    },
    removeitems: function(){
      $(document.body).on('click','#remove-item', function(){
        var t = $(this);
        var id = t.data('id');
        $.ajax({
            type: "post",
            url: "/cart/change.js",
            data: 'quantity=0&id=' + id,
            dataType: 'json',
            success: function(cart) {
              jQuery('[data-product-id="'+id+'"],[data-item-id="'+id+'"]').remove();
              yfb.getItems(); 
              
            },
            error: function(xhr) {          
                 
            }
        });
      });
    },
  };
  yfb.init();
    $(document.body).on('focus', '#DSearch', function() {
    $('.yfb_search_bar').addClass('active');
});
$('.yfb_pdp .content h5').on('click', function(){
  $('html, body').animate({
      scrollTop: $("#yfb_ingred").offset().top
  }, 1000);
});
$(document.body).on('blur', '#DSearch', function() {
    $('.yfb_search_bar').removeClass('active');
});
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) { 

  $('#california-seasonal,#abbotsford-british-columbia').on('click', function(){
    jQuery('html, body').animate({
        scrollTop: jQuery("#locations").offset().top - 100
    }, 1000); 
    });
  $('#southern-california').on('click', function(){
    jQuery('html, body').animate({
        scrollTop: jQuery("#locations").offset().top - 100
    }, 1000); 
  });
  $('#turkey-seasonal').on('click', function(){
    jQuery('html, body').animate({
        scrollTop: jQuery("#locations").offset().top - 280
    }, 1000); 
  });$('#maharashtra-india').on('click', function(){
    jQuery('html, body').animate({
        scrollTop: jQuery("#locations").offset().top - 350
    }, 1000); 
  });

var headc = $('#headc').html();
$('#mheadc').html(headc); $('#headc').html(''); }
    var w = window.innerWidth;
     
   $(document.body).on('submit', '#add-to_cart,[data-type="add-to-cart-form"]',function (e) {
     e.preventDefault();
      var t = $(this);
     var data = t.serialize();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
          yfb.getItems();
          var myOffcanvas = document.getElementById('yfb-sidecart');
          var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
          bsOffcanvas.show();
        }
      });
    });
 
  $(document.body).on('click', '.yfb_faqs .card-header a', function(){
    var t = $(this);
    t.parent().parent().toggleClass('active').siblings().removeClass('active');
  });
   
   $(document.body).on('click', '#yfb_addcart',function (e) {
      var id = $(this).attr('data-id'); e.preventDefault();
     
      datass = {
        "id": id,
        "quantity": 1
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: datass,
        dataType: 'json',
        success: function (cart) {
          yfb.getItems();
          var myOffcanvas = document.getElementById('yfb-sidecart');
          var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
          bsOffcanvas.show();
        }
      });
    });
   
  $(document.body).on('click', '[data-plus]', function(e){
        e.preventDefault();
        var t = $(this),
         qty = t.siblings('input[type="text"]'),
         max_q = qty.data('max'),
         productId = qty.data('id'),
         q = parseInt(qty.val())+1;
        if( q < max_q || q == max_q ){
         
           
          qty.val(q);
          if(productId){
            $.ajax({
                type: "post",
                url: "/cart/change.js",
                data: 'quantity='+q+'&id=' + productId,
                dataType: 'json',
                success: function(cart) {
                   yfb.getItems();
                },
                error: function(xhr) {}
            });
          }
        }
        if( q > max_q ){
        	$('[data-lmtqty="'+productId+'"]').html('<div class="limited_qty"><i class="fa fa-info-circle"></i> Maximum quantity '+ max_q+'</div>');
          setTimeout(function(){ $('[data-lmtqty="'+productId+'"]').html('') }, 1500 );
        }
      });
      
    $('#topbar_txt').slick({
      arrows:false,
      infinite: true,
      speed: 500,
      autoplay:true,
      slidesToScroll: 1
    });


    $('#larg-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,swipeToSlide:false,swipe:false,
      fade: true,
      asNavFor: '#thumbnail-slider'
    });
    $('#thumbnail-slider').slick({
      dots: false,arrows:true,
      infinite: true,
      speed: 300,
      slidesToScroll: 1,asNavFor: '#larg-slider',
      slidesToShow: 4,focusOnSelect: true,centerMode: false,
      nextArrow:'<span class="nextarr"><svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.84375 12.0938L6.46875 6.46875L0.84375 0.843749" stroke="black" stroke-width="1.6875" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
      responsive: [
        {
          breakpoint: 410,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    });
    $('#productslider').slick({
      dots: true,arrows:true,
      slidesToScroll: 1, slidesToShow: 5,
      nextArrow:'<span class="prevarw"><svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.5864 36.2261L12.8603 19.5001L29.5863 2.7742C30.2216 2.13886 30.2216 1.11185 29.5863 0.476507C28.9509 -0.158836 27.9239 -0.158836 27.2886 0.476507L9.41376 18.3513C8.77842 18.9867 8.77842 20.0137 9.41376 20.649L27.2886 38.5238C27.6054 38.8407 28.0214 39 28.4375 39C28.8534 39 29.2695 38.8407 29.5864 38.5238C30.2217 37.8885 30.2217 36.8615 29.5864 36.2261Z" fill="black"/></svg></span>',
      prevArrow:'',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    $('a[href="#product_slider"]').on('click', function(e){
      e.preventDefault();
      jQuery('html, body').animate({
          scrollTop: jQuery("#product_slider").offset().top - 200
      }, 1000);
    });
    $('#procedure_slider').slick({
      dots: false,arrows:true,
      infinite: true,
      speed: 300,
      slidesToScroll: 1,
      variableWidth: true,
      nextArrow:'<span class="prevarw"><svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.5864 36.2261L12.8603 19.5001L29.5863 2.7742C30.2216 2.13886 30.2216 1.11185 29.5863 0.476507C28.9509 -0.158836 27.9239 -0.158836 27.2886 0.476507L9.41376 18.3513C8.77842 18.9867 8.77842 20.0137 9.41376 20.649L27.2886 38.5238C27.6054 38.8407 28.0214 39 28.4375 39C28.8534 39 29.2695 38.8407 29.5864 38.5238C30.2217 37.8885 30.2217 36.8615 29.5864 36.2261Z" fill="black"/></svg></span>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    
      $('#MobileMenu').on('click', function(){
        var t = $(this);
        t.toggleClass('active'); $('#mobile_menu').slideToggle();
      });
      $(document).on('click', function(e) {
        // Check if click is outside both the menu button and menu content
        if (!$(e.target).closest('#MobileMenu, #mobile_menu').length) {
          $('#MobileMenu').removeClass('active');
          $('#mobile_menu').slideUp();
        }
      });
    $('li.child_menu').on('click', function(e){
      $(this).toggleClass('opened').siblings().removeClass('opened');
    });
    
    $('.site-header ul li ul').on('mouseleave', function(e){
      $('li.child_menu').removeClass('opened');
    });
    $(document.body).on('click', '[data-minus]', function(e){
      e.preventDefault();
      var t = $(this);
      let qty = t.siblings('input[type="text"]');
      let minus = parseInt(qty.val())-1;
      let productId = qty.data('id');
      if( minus > 0 ){
        qty.val(minus);
        if( productId ){
          $.ajax({
              type: "post",
              url: "/cart/change.js",
              data: 'quantity='+minus+'&id=' + productId,
              dataType: 'json',
              success: function(cart) {
                yfb.getItems();
              },
              error: function(xhr) {}
          });
        }
      }
    });
  $(document.body).on('click','#searchbar', function(){
    $(this).hide();
    $('.yfb_search_bar').addClass('opened');
  });
  $(document.body).on('click','.yfb_search_bar .closebar', function(){
    $('#searchbar').show();
    $('.yfb_search_bar').removeClass('opened');
  });

  
});
